import React, { useEffect, useState } from 'react';
import './LoadingScreen.css';

function LoadingScreen() {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    let interval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          clearInterval(interval);
          return 100;
        }
        return prev + 1;
      });
    }, 20); // 100 x 20ms = 2s

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="loading-container">
      <img
        src="/logo.webp"
        alt="Logo"
        className="loading-logo"
        style={{
          filter: `brightness(${0.2 + progress / 100 * 0.8})`,
          opacity: `${0.2 + progress / 100 * 0.8}`,
          color : "#121417",
          transition: "all 0.2s linear"
        }}
      />
          <div className="progress-wrapper">
        <div
          className="progress-bar"
          style={{ width: `${progress}%` }}
        ></div>
      </div>
    </div>
  );
}

export default LoadingScreen;
